var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBicycleFront = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 92,
    viewBox: "0 0 28 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5244 74.8459H12.3365",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5244 83.1441V74.8459",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42261 83.144H10.5245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42261 82.3603V83.1441",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84493 82.3603H5.42261",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84489 73.5624V82.3603",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3365 73.5624H9.84489",
    stroke: "black",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7449 65.2606V71.8222",
    stroke: "black",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8468 65.2606H15.7449",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8468 66.0444V65.2606",
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4245 66.0444H20.8468",
    stroke: "black",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4245 74.8459V66.0444",
    stroke: "black",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 74.8459H16.4245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7449 73.5624H13.9329",
    stroke: "black",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7449 72.2068V73.5623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3365 87.1817C12.3461 87.3875 12.4349 87.5817 12.5843 87.7236C12.7337 87.8655 12.9321 87.9442 13.1381 87.9433C13.3442 87.9424 13.5419 87.8619 13.69 87.7186C13.8381 87.5753 13.9251 87.3804 13.9329 87.1745",
    stroke: "black",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 56.8474V87.1745",
    stroke: "black",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 56.8475C13.9241 56.6416 13.8362 56.4472 13.6875 56.3046C13.5388 56.1621 13.3407 56.0825 13.1347 56.0825C12.9287 56.0825 12.7306 56.1621 12.5819 56.3046C12.4332 56.4472 12.3453 56.6416 12.3365 56.8475",
    stroke: "black",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3365 87.1817V56.8474",
    stroke: "black",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6246 54.8161H13.1347",
    stroke: "black",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2435 72.3832L11.6246 54.8161",
    stroke: "black",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7438 72.3831H11.2435",
    stroke: "black",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7438 53.1658V72.3831",
    stroke: "black",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1347 53.1658H10.7438",
    stroke: "black",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6447 54.8161H13.1347",
    stroke: "black",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0295 72.3832L14.6448 54.8161",
    stroke: "black",
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5292 72.3831H15.0295",
    stroke: "black",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5292 53.1658V72.3831",
    stroke: "black",
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1347 53.1658H15.5292",
    stroke: "black",
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4942 39.4062V46.9026",
    stroke: "black",
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4942 39.4062C13.4942 39.3109 13.4563 39.2194 13.3889 39.152C13.3215 39.0846 13.23 39.0467 13.1347 39.0467C13.0393 39.0467 12.9479 39.0846 12.8805 39.152C12.813 39.2194 12.7751 39.3109 12.7751 39.4062",
    stroke: "black",
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7751 46.9026V39.4062",
    stroke: "black",
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95733 38.7806L4.99832 37.2706",
    stroke: "black",
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95732 38.7806C8.53361 39.2549 9.25677 39.5141 10.0031 39.5141",
    stroke: "black",
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7751 39.514H10.0031",
    stroke: "black",
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59061 39.3487L4.69273 37.8674",
    stroke: "black",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59062 39.3487C8.27769 39.8913 9.12763 40.1864 10.0031 40.1864",
    stroke: "black",
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7751 40.1865H10.0031",
    stroke: "black",
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.312 38.7807L22.4575 36.6666",
    stroke: "black",
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2663 39.5141C17.0126 39.5141 17.7357 39.2549 18.312 38.7806",
    stroke: "black",
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4942 39.514H16.2663",
    stroke: "black",
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6824 39.3487L22.515 37.3892",
    stroke: "black",
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2663 40.1864C17.143 40.1873 17.9943 39.8921 18.6824 39.3487",
    stroke: "black",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4942 40.1865H16.2663",
    stroke: "black",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3149 36.7672C27.5284 36.4638 27.6327 36.0968 27.6104 35.7265C27.5882 35.3561 27.4409 35.0043 27.1926 34.7286",
    stroke: "black",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32384 37.6948C1.83546 38.1569 2.47642 38.4512 3.16039 38.538C3.84436 38.6248 4.5385 38.4999 5.14933 38.1801",
    stroke: "black",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45592 35.2392C3.00659 35.229 2.56187 35.3317 2.16241 35.5377C1.76296 35.7437 1.4215 36.0465 1.16925 36.4185",
    stroke: "black",
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28021 27.4911C3.22524 24.7576 3.89021 21.9351 4.26487 19.0671",
    stroke: "black",
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16925 36.4185C1.03628 36.6139 0.978666 36.851 1.00709 37.0856C1.03552 37.3203 1.14806 37.5368 1.32385 37.6948",
    stroke: "black",
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67619 35.7605C1.50645 35.2019 1.29616 34.6563 1.047 34.1282",
    stroke: "black",
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89552 30.4069C1.22433 31.5256 0.927103 32.8291 1.04701 34.1281",
    stroke: "black",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28022 27.4911C1.92586 28.5145 1.71179 29.5813 1.64384 30.6622",
    stroke: "black",
    strokeWidth: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1368 1.37066C15.9592 1.22812 15.7545 1.12309 15.5351 1.06191C15.3157 1.00073 15.0862 0.984677 14.8605 1.01472",
    stroke: "black",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7104 1.13692C12.2537 1.12959 11.8074 1.27371 11.4413 1.5468",
    stroke: "black",
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7104 1.13695C13.4292 1.1503 14.1479 1.10944 14.8605 1.01471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7487 16.6223C22.4353 16.2979 22.0254 16.0835 21.5802 16.011",
    stroke: "black",
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5721 25.9379C23.5491 27.1295 23.5923 28.3214 23.7015 29.5081",
    stroke: "black",
    strokeWidth: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4966 37.2994C23.5623 37.2127 23.5948 37.1053 23.5884 36.9967C23.582 36.8881 23.5371 36.7853 23.4617 36.7069C23.3863 36.6284 23.2854 36.5795 23.1771 36.5688C23.0688 36.5581 22.9603 36.5864 22.871 36.6486",
    stroke: "black",
    strokeWidth: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4966 37.2993C23.1791 37.3238 22.8634 37.3671 22.551 37.4287",
    stroke: "black",
    strokeWidth: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.213 36.0338C22.1658 36.1091 22.1436 36.1975 22.1497 36.2863C22.1557 36.3751 22.1897 36.4596 22.2468 36.5279C22.3039 36.5961 22.3811 36.6446 22.4674 36.6663C22.5537 36.6879 22.6446 36.6817 22.7272 36.6486",
    stroke: "black",
    strokeWidth: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9676 30.9247C23.1018 30.9056 22.2551 31.1807 21.5659 31.7049",
    stroke: "black",
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7015 29.5082C22.8163 29.6919 21.9923 30.0977 21.307 30.6875",
    stroke: "black",
    strokeWidth: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7842 19.3116C23.6837 21.5194 23.6129 23.7283 23.5721 25.9379",
    stroke: "black",
    strokeWidth: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0064 4.26855C17.8968 4.91228 17.9274 5.57209 18.0963 6.20287",
    stroke: "black",
    strokeWidth: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9597 7.87833C18.197 7.35229 18.2452 6.76042 18.0963 6.20288",
    stroke: "black",
    strokeWidth: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9597 7.8783C17.779 8.27872 17.6941 8.71571 17.7116 9.15465",
    stroke: "black",
    strokeWidth: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6828 4.41955C17.8161 4.39138 17.9395 4.32804 18.04 4.23612C18.1406 4.14419 18.2147 4.02703 18.2547 3.89679C18.2947 3.76655 18.2991 3.62797 18.2674 3.49546C18.2358 3.36294 18.1693 3.24131 18.0748 3.14319",
    stroke: "black",
    strokeWidth: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9667 7.5188C11.8969 6.56974 12.5454 5.38107 12.8399 4.08521",
    stroke: "black",
    strokeWidth: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5249 4.10669C9.06004 5.372 9.03094 6.75631 9.44222 8.04004",
    stroke: "black",
    strokeWidth: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81974 10.3304C9.80605 9.55263 9.67887 8.78108 9.44223 8.0401",
    stroke: "black",
    strokeWidth: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9667 7.5188L10.9882 10.7259",
    stroke: "black",
    strokeWidth: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8399 4.08521C14.3922 4.64233 16.0687 4.75808 17.6828 4.41958",
    stroke: "black",
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9113 12.7464C14.223 12.9216 14.575 13.0124 14.9325 13.0099C15.29 13.0074 15.6407 12.9116 15.9499 12.7321",
    stroke: "black",
    strokeWidth: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3454 11.9663C16.0576 12.2331 15.8784 12.5967 15.842 12.9874",
    stroke: "black",
    strokeWidth: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M15.842 12.9874C15.9952 13.5283 16.3075 14.0105 16.7384 14.3715C17.1693 14.7325 17.6988 14.9556 18.2581 15.0116",
    stroke: "black",
    strokeWidth: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7474 14.145C11.5466 14.9765 12.624 15.4845 13.774 15.5721C14.924 15.6596 16.0659 15.3206 16.9818 14.6196",
    stroke: "black",
    strokeWidth: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81975 10.3304C9.82144 10.4657 9.86509 10.5972 9.94467 10.7067C10.0242 10.8162 10.1358 10.8983 10.264 10.9417C10.3922 10.9851 10.5307 10.9876 10.6605 10.949C10.7902 10.9103 10.9047 10.8324 10.9882 10.7259",
    stroke: "black",
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3454 11.9663C17.1364 11.2329 17.6238 10.2297 17.7116 9.15466",
    stroke: "black",
    strokeWidth: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6071 14.2961C11.0644 13.8314 11.3509 13.2257 11.4201 12.5774C11.4893 11.9292 11.3371 11.2766 10.9882 10.7259",
    stroke: "black",
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79962 16.3598C6.14739 16.49 5.55226 16.8211 5.09769 17.3066C4.64312 17.7921 4.35191 18.4077 4.26488 19.0671",
    stroke: "black",
    strokeWidth: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79962 16.3598C8.24668 16.0683 9.57301 15.3494 10.6071 14.296",
    stroke: "black",
    strokeWidth: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7718 29.9324C19.7393 30.8337 19.8684 31.7335 20.1529 32.5894",
    stroke: "black",
    strokeWidth: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92858 34.1929C8.1503 32.7191 8.14059 31.2197 7.89981 29.749",
    stroke: "black",
    strokeWidth: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1285 33.5529C14.1113 34.2487 17.2391 33.9611 20.045 32.7332",
    stroke: "black",
    strokeWidth: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2464 24.4314C19.9782 26.2539 19.8198 28.0908 19.7718 29.9323",
    stroke: "black",
    strokeWidth: 0.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61674 31.4029C5.44444 31.7479 5.36821 32.1329 5.39605 32.5176C5.42388 32.9022 5.55475 33.2723 5.77494 33.5889",
    stroke: "black",
    strokeWidth: 0.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92546 36.8931C6.70905 37.2379 6.54658 37.6138 6.44368 38.0077",
    stroke: "black",
    strokeWidth: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14215 37.1591C5.09137 37.1173 5.03189 37.0874 4.96807 37.0716C4.90425 37.0558 4.8377 37.0545 4.7733 37.0678C4.7089 37.081 4.64828 37.1085 4.59588 37.1482C4.54348 37.1879 4.50063 37.2388 4.47046 37.2973C4.44029 37.3557 4.42357 37.4201 4.42152 37.4858C4.41948 37.5515 4.43217 37.6169 4.45865 37.677C4.48513 37.7372 4.52473 37.7907 4.57456 37.8336C4.6244 37.8765 4.6832 37.9077 4.74665 37.9249",
    stroke: "black",
    strokeWidth: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73227 35.631C4.35123 35.3849 3.90942 35.2493 3.45592 35.2391",
    stroke: "black",
    strokeWidth: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79291 36.3897C5.45132 36.1205 5.09739 35.8673 4.73227 35.631",
    stroke: "black",
    strokeWidth: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25362 37.4143C5.38526 37.4566 5.52759 37.4511 5.65557 37.3988C5.78356 37.3465 5.88902 37.2507 5.95341 37.1284C6.01781 37.006 6.03701 36.8649 6.00766 36.7298C5.97831 36.5947 5.90228 36.4742 5.79292 36.3896",
    stroke: "black",
    strokeWidth: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03381 34.2037C5.8927 34.8383 5.81205 35.4847 5.79292 36.1345",
    stroke: "black",
    strokeWidth: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0338 34.2037C6.05935 34.0871 6.04818 33.9654 6.00184 33.8553C5.95549 33.7452 5.87623 33.6522 5.77493 33.5889",
    stroke: "black",
    strokeWidth: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77493 33.5889C4.92688 33.0594 3.9241 32.8338 2.93098 32.9489",
    stroke: "black",
    strokeWidth: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05898 20.6959C6.60025 21.6483 7.29512 22.5048 8.11554 23.2307",
    stroke: "black",
    strokeWidth: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61673 31.4029C6.93348 28.7605 7.53118 25.8179 7.34971 22.8711",
    stroke: "black",
    strokeWidth: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8998 29.749C7.71108 28.5929 7.4977 27.4409 7.25983 26.2939",
    stroke: "black",
    strokeWidth: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92548 36.8931C7.44231 36.0718 7.78383 35.1525 7.92859 34.1929",
    stroke: "black",
    strokeWidth: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2581 15.0116C19.317 15.4887 20.4339 15.8247 21.5802 16.0111",
    stroke: "black",
    strokeWidth: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3228 25.208C19.3345 24.9752 20.2466 24.4282 20.9286 23.6455C21.6105 22.8628 22.0274 21.8844 22.1196 20.8504",
    stroke: "black",
    strokeWidth: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1529 32.7332C20.4929 33.9898 21.1676 35.1306 22.1052 36.0337",
    stroke: "black",
    strokeWidth: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0748 3.14313C17.4669 2.51187 16.8197 1.91983 16.1368 1.37061",
    stroke: "black",
    strokeWidth: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4413 1.54681C10.5674 2.1959 9.90153 3.08542 9.52492 4.10673",
    stroke: "black",
    strokeWidth: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7698 40.6107C23.6102 40.9249 23.5192 41.2696 23.5031 41.6217C23.487 41.9738 23.5461 42.3253 23.6763 42.6528",
    stroke: "black",
    strokeWidth: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9865 58.0662C21.9468 58.6263 21.9867 59.1892 22.1052 59.7381",
    stroke: "black",
    strokeWidth: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8396 61.0217C21.015 61.0573 21.1965 61.0486 21.3677 60.9964C21.5389 60.9442 21.6943 60.8501 21.82 60.7227C21.9456 60.5952 22.0375 60.4385 22.0873 60.2665C22.1371 60.0946 22.1432 59.913 22.1052 59.7382",
    stroke: "black",
    strokeWidth: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9496 45.8168C23.1134 49.8687 22.4583 53.9559 21.9865 58.0662",
    stroke: "black",
    strokeWidth: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M14.145 48.3085V47.2586",
    stroke: "black",
    strokeWidth: 0.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14.465 47.2586V46.9026",
    stroke: "black",
    strokeWidth: 0.5
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M14.145 47.2586H14.465",
    stroke: "black",
    strokeWidth: 0.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8298 42.5378C17.9436 44.0961 17.3033 45.7818 16.9314 47.5354",
    stroke: "black",
    strokeWidth: 0.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M12.128 47.2586H13.1347",
    stroke: "black",
    strokeWidth: 0.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M12.128 47.2586H11.8044",
    stroke: "black",
    strokeWidth: 0.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8044 47.2586V46.9026",
    stroke: "black",
    strokeWidth: 0.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8044 46.9026H13.1347",
    stroke: "black",
    strokeWidth: 0.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M12.128 48.3085V47.2586",
    stroke: "black",
    strokeWidth: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M14.465 46.9026H13.1347",
    stroke: "black",
    strokeWidth: 0.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M14.145 47.2586H13.1347",
    stroke: "black",
    strokeWidth: 0.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8502 43.843C14.1262 44.555 14.6733 45.1286 15.3715 45.438C16.0697 45.7473 16.8621 45.7672 17.575 45.4932",
    stroke: "black",
    strokeWidth: 0.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M14.145 53.1658V52.1231",
    stroke: "black",
    strokeWidth: 0.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.128 53.1658V52.1231",
    stroke: "black",
    strokeWidth: 0.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4192 57.6743H13.7171",
    stroke: "black",
    strokeWidth: 0.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2919 50.2141L15.2236 50.7498",
    stroke: "black",
    strokeWidth: 0.5
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2236 50.7496L15.0259 51.253",
    stroke: "black",
    strokeWidth: 0.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0259 51.2531L14.7059 51.6917",
    stroke: "black",
    strokeWidth: 0.5
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7059 51.6917L14.2888 52.0369",
    stroke: "black",
    strokeWidth: 0.5
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2888 52.0368L13.7998 52.2669",
    stroke: "black",
    strokeWidth: 0.5
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7998 52.2669L13.2713 52.3676",
    stroke: "black",
    strokeWidth: 0.5
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2713 52.3676L12.732 52.3352",
    stroke: "black",
    strokeWidth: 0.5
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12.732 52.3352L12.2179 52.1663",
    stroke: "black",
    strokeWidth: 0.5
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2179 52.1663L11.7612 51.8751",
    stroke: "black",
    strokeWidth: 0.5
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7613 51.875L11.3909 51.4831",
    stroke: "black",
    strokeWidth: 0.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3909 51.4831L11.1285 51.0085",
    stroke: "black",
    strokeWidth: 0.5
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1285 51.0085L10.9954 50.4871",
    stroke: "black",
    strokeWidth: 0.5
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9954 50.4872V49.9443",
    stroke: "black",
    strokeWidth: 0.5
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9954 49.9444L11.1285 49.423",
    stroke: "black",
    strokeWidth: 0.5
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1285 49.423L11.3909 48.9484",
    stroke: "black",
    strokeWidth: 0.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3909 48.9485L11.7613 48.553",
    stroke: "black",
    strokeWidth: 0.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7612 48.5528L12.2179 48.2652",
    stroke: "black",
    strokeWidth: 0.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2179 48.2652L12.732 48.0963",
    stroke: "black",
    strokeWidth: 0.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M12.732 48.0963L13.2713 48.064",
    stroke: "black",
    strokeWidth: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2713 48.064L13.7998 48.1646",
    stroke: "black",
    strokeWidth: 0.5
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7998 48.1646L14.2888 48.3947",
    stroke: "black",
    strokeWidth: 0.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2888 48.3947L14.7059 48.7398",
    stroke: "black",
    strokeWidth: 0.5
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7059 48.7399L15.0259 49.1749",
    stroke: "black",
    strokeWidth: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0259 49.1749L15.2236 49.6782",
    stroke: "black",
    strokeWidth: 0.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2236 49.6783L15.2919 50.214",
    stroke: "black",
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9314 47.5354C16.8264 48.0308 16.8429 48.5443 16.9794 49.0321C17.1159 49.5198 17.3683 49.9672 17.7152 50.3362",
    stroke: "black",
    strokeWidth: 0.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83964 43.5266C5.36909 47.8824 5.34741 52.2751 5.77492 56.6354",
    stroke: "black",
    strokeWidth: 0.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7979 63.6967C18.4099 62.48 18.6666 61.1155 18.5385 59.7597",
    stroke: "black",
    strokeWidth: 0.5
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4271 59.7632C18.7167 59.9709 19.0092 60.1747 19.3044 60.3745",
    stroke: "black",
    strokeWidth: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4271 59.7632C18.2972 59.6699 18.1471 59.6085 17.9891 59.5841C17.831 59.5598 17.6694 59.5731 17.5175 59.623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1507 59.2599C17.1343 59.3108 17.1322 59.3653 17.1449 59.4173C17.1575 59.4693 17.1844 59.5167 17.2224 59.5543C17.2604 59.592 17.3081 59.6183 17.3602 59.6305C17.4123 59.6426 17.4667 59.64 17.5175 59.6231",
    stroke: "black",
    strokeWidth: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59062 62.1218C7.81487 62.3163 8.07953 62.4585 8.36548 62.5381C8.65143 62.6178 8.9515 62.6328 9.24398 62.5823C9.53647 62.5317 9.81405 62.4167 10.0566 62.2457C10.2992 62.0746 10.5008 61.8518 10.6467 61.5933",
    stroke: "black",
    strokeWidth: 0.5
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8109 62.3879C6.10245 61.3084 6.18181 60.1826 6.0446 59.0729",
    stroke: "black",
    strokeWidth: 0.5
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77493 56.6353C5.85463 57.449 5.94452 58.2616 6.04459 59.073",
    stroke: "black",
    strokeWidth: 0.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1507 59.26C18.1444 56.117 18.2118 52.7543 17.3449 49.574",
    stroke: "black",
    strokeWidth: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8679 62.3987C21.4734 61.972 20.9523 61.6833 20.3814 61.5752C19.8104 61.4671 19.2199 61.5453 18.6967 61.7983",
    stroke: "black",
    strokeWidth: 0.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3044 60.3745C19.7682 60.6898 20.29 60.9098 20.8396 61.0217",
    stroke: "black",
    strokeWidth: 0.5
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9141 43.2748C21.4237 48.6711 20.1333 54.1206 19.0455 59.6123",
    stroke: "black",
    strokeWidth: 0.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31783 38.6799C5.94872 40.2678 5.78796 41.8971 5.83963 43.5265",
    stroke: "black",
    strokeWidth: 0.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32501 38.7015C6.30876 38.9013 6.30757 39.102 6.32143 39.302",
    stroke: "black",
    strokeWidth: 0.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7842 19.3117C23.8003 18.8169 23.717 18.324 23.5391 17.862C23.3613 17.4001 23.0925 16.9785 22.7488 16.6223",
    stroke: "black",
    strokeWidth: 0.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0246 34.3115C24.8842 33.6264 24.5138 33.0098 23.9748 32.5641",
    stroke: "black",
    strokeWidth: 0.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9748 32.5642C24.0903 32.0258 24.1363 31.4748 24.1114 30.9247",
    stroke: "black",
    strokeWidth: 0.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M22.551 37.4288C23.3134 37.8347 24.1847 37.9893 25.0402 37.8704C25.8958 37.7516 26.6919 37.3655 27.3149 36.7672",
    stroke: "black",
    strokeWidth: 0.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3041 34.8365C26.468 34.3287 25.4659 34.1696 24.5136 34.3935C23.5613 34.6174 22.7351 35.2065 22.213 36.0338",
    stroke: "black",
    strokeWidth: 0.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1114 30.9247C24.1731 30.6957 24.1673 30.4536 24.0946 30.2278C24.0219 30.0019 23.8854 29.802 23.7015 29.652",
    stroke: "black",
    strokeWidth: 0.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9496 45.8168C24.1683 44.7581 24.0733 43.6585 23.6764 42.6529",
    stroke: "black",
    strokeWidth: 0.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7698 40.6107C24.1417 39.7522 24.2854 38.8121 24.1869 37.8818",
    stroke: "black",
    strokeWidth: 0.5
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1339 64.3258C22.1547 63.2098 22.0253 62.096 21.7492 61.0145",
    stroke: "black",
    strokeWidth: 0.5
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7979 63.6967C17.7178 63.8555 17.6793 64.0322 17.6861 64.21C17.6929 64.3878 17.7447 64.561 17.8366 64.7133C17.9286 64.8657 18.0578 64.9922 18.212 65.081C18.3662 65.1698 18.5404 65.218 18.7183 65.2211",
    stroke: "black",
    strokeWidth: 0.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69391 72.0488C10.7104 68.8742 10.9508 65.5021 10.395 62.2154",
    stroke: "black",
    strokeWidth: 0.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81089 62.388C4.6829 66.5587 4.65936 70.9511 5.74257 75.1336",
    stroke: "black",
    strokeWidth: 0.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4192 76.9312V57.6743",
    stroke: "black",
    strokeWidth: 0.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7171 57.6743V90.9999",
    stroke: "black",
    strokeWidth: 0.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2674 65.2067C21.4973 65.1991 21.7154 65.1034 21.8767 64.9395C22.038 64.7755 22.1301 64.5558 22.1339 64.3259",
    stroke: "black",
    strokeWidth: 0.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5292 72.2068H15.86",
    stroke: "black",
    strokeWidth: 0.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5292 71.8223H15.86",
    stroke: "black",
    strokeWidth: 0.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M15.86 71.8223V72.207",
    stroke: "black",
    strokeWidth: 0.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 72.2068H15.0259",
    stroke: "black",
    strokeWidth: 0.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 71.8223H15.0151",
    stroke: "black",
    strokeWidth: 0.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3365 71.8223H11.2543",
    stroke: "black",
    strokeWidth: 0.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3365 72.2068H11.2471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4094 71.8223V72.207",
    stroke: "black",
    strokeWidth: 0.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7438 71.8223H10.4094",
    stroke: "black",
    strokeWidth: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7438 72.2068H10.4094",
    stroke: "black",
    strokeWidth: 0.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74258 75.1335C5.79886 75.3497 5.89996 75.5517 6.03932 75.7264C6.17868 75.9011 6.35319 76.0445 6.55155 76.1474",
    stroke: "black",
    strokeWidth: 0.5
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7183 65.2211C19.568 65.2374 20.418 65.2326 21.2674 65.2067",
    stroke: "black",
    strokeWidth: 0.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83101 79.4875L9.50334 82.2452",
    stroke: "black",
    strokeWidth: 0.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7171 91H12.4192",
    stroke: "black",
    strokeWidth: 0.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4192 91V76.9312",
    stroke: "black",
    strokeWidth: 0.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65988 79.2108L7.08006 79.5667",
    stroke: "black",
    strokeWidth: 0.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12369 79.3293L5.16373 81.5082",
    stroke: "black",
    strokeWidth: 0.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16373 81.5082C5.18223 81.6682 5.23704 81.8219 5.32399 81.9575C5.41094 82.0931 5.52772 82.207 5.66542 82.2906C5.80312 82.3742 5.9581 82.4252 6.11853 82.4398C6.27896 82.4544 6.44059 82.4321 6.59109 82.3747",
    stroke: "black",
    strokeWidth: 0.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57622 77.2692L6.83197 80.4799",
    stroke: "black",
    strokeWidth: 0.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83197 80.4799L9.73705 79.0417",
    stroke: "black",
    strokeWidth: 0.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65988 79.2108C6.00218 78.1318 6.17443 77.0062 6.17043 75.8743",
    stroke: "black",
    strokeWidth: 0.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69392 72.0488C8.96396 74.325 8.97909 76.7747 9.73707 79.0418",
    stroke: "black",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBicycleFront);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bicycleFront.80a58f3d060539f223fe99faa625ab36.svg";